// extracted by mini-css-extract-plugin
export var hidden = "_np-1";
export var visible = "_np-0";